/**
 * The last few sections somebody visited, in `localStorage`.
 *
 * Only sections — never an entity. A purchase opened once is not somewhere you
 * go back to; Signups is. Keeping entities out is also what keeps this from
 * becoming a list of customer names sitting in a shared browser.
 *
 * Every read is defensive: this is a string somebody could have edited, and a
 * palette that throws because of it would be worse than one with no history.
 */

const KEY = 'ws-next-recent';
const LIMIT = 8;

export const readRecent = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(parsed)
      ? parsed.filter(entry => entry && typeof entry.to === 'string' && typeof entry.label === 'string')
      : [];
  } catch (error) {
    return [];
  }
};

export const rememberRecent = entry => {
  if (!entry || !entry.to) return;
  try {
    const rest = readRecent().filter(item => item.to !== entry.to);
    localStorage.setItem(KEY, JSON.stringify([entry, ...rest].slice(0, LIMIT)));
  } catch (error) {
    // A full or disabled localStorage costs the history, not the palette.
  }
};
